import { CUSTOMER_TYPES, POLICY_CLASSES } from '@shared/constants';
import { IPolicy } from '@shared/interfaces';

const isPolicyTypeAndClass = (
  policy: any,
  type: CUSTOMER_TYPES,
  classType: POLICY_CLASSES
): boolean => {
  return (
    policy?.customer_information?.type === type &&
    policy?.customer_information?.class_type === classType
  );
};

export const isLifeHealthFlow = (policy: any): boolean => {
  const classType = (
    policy?.customer_information?.class_type ||
    policy?.class_type ||
    policy?.policy_class ||
    ''
  ).toUpperCase();
  return classType === POLICY_CLASSES.LIFE_HEALTH;
};

export const isLifeHealthGroup = (policy: any): boolean => {
  const custType = (
    policy?.customer_information?.type ||
    policy?.proposer_details?.customer_type ||
    policy?.type ||
    ''
  ).toUpperCase();
  return (
    isLifeHealthFlow(policy) &&
    (custType === CUSTOMER_TYPES.GROUP ||
      custType === CUSTOMER_TYPES.ORGANIZATION)
  );
};

export const isLifeHealthIndividual = (policy: any): boolean => {
  const custType = (
    policy?.customer_information?.type ||
    policy?.proposer_details?.customer_type ||
    policy?.type ||
    ''
  ).toUpperCase();
  return isLifeHealthFlow(policy) && custType === CUSTOMER_TYPES.INDIVIDUAL;
};

export const getPolicyTypeAndClass = (
  policy: IPolicy
): {
  isMotorIndividual: boolean;
  isMotorFleet: boolean;
  isMedicalIndividual: boolean;
  isMedicalGroup: boolean;
  isLifeHealthIndividual: boolean;
  isLifeHealthGroup: boolean;
  isLifeHealthFlow: boolean;
  isTravelGroup: boolean;
  isTravelIndividual: boolean;
  isFireIndividual: boolean;
  isFireGroup: boolean;
  isMarineIndividual: boolean;
  isMarineGroup: boolean;
  isMiscIndividual: boolean;
  isMiscGroup: boolean;
  isPackage: boolean;
} => {
  const lifeHealthFlow = isLifeHealthFlow(policy);
  return {
    isMotorIndividual: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.INDIVIDUAL,
      POLICY_CLASSES.MOTOR
    ),
    isMotorFleet: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.FLEET,
      POLICY_CLASSES.MOTOR
    ),
    isMedicalIndividual:
      !lifeHealthFlow &&
      isPolicyTypeAndClass(
        policy,
        CUSTOMER_TYPES.INDIVIDUAL,
        POLICY_CLASSES.MEDICAL
      ),
    isMedicalGroup:
      !lifeHealthFlow &&
      isPolicyTypeAndClass(
        policy,
        CUSTOMER_TYPES.ORGANIZATION,
        POLICY_CLASSES.MEDICAL
      ),
    isLifeHealthIndividual: isLifeHealthIndividual(policy),
    isLifeHealthGroup: isLifeHealthGroup(policy),
    isLifeHealthFlow: lifeHealthFlow,
    isTravelGroup: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.GROUP,
      POLICY_CLASSES.TRAVEL
    ),
    isTravelIndividual: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.INDIVIDUAL,
      POLICY_CLASSES.TRAVEL
    ),
    isFireIndividual: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.INDIVIDUAL,
      POLICY_CLASSES.FIRE
    ),
    isFireGroup: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.GROUP,
      POLICY_CLASSES.FIRE
    ),
    isMarineIndividual: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.INDIVIDUAL,
      POLICY_CLASSES.MARINE
    ),
    isMarineGroup: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.GROUP,
      POLICY_CLASSES.MARINE
    ),
    isMiscIndividual: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.INDIVIDUAL,
      POLICY_CLASSES.MISCELLANEOUS
    ),
    isMiscGroup: isPolicyTypeAndClass(
      policy,
      CUSTOMER_TYPES.GROUP,
      POLICY_CLASSES.MISCELLANEOUS
    ),
    isPackage:
      policy?.customer_information?.class_type === POLICY_CLASSES.PACKAGES,
  };
};
